import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";

export default function MainNavbar() {
  return (
    <>
      <Navbar expand="lg" data-bs-theme="dark" bg="success" className="main-navbar">
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/main_page">Карта</Nav.Link>
              <Nav.Link href="/comparison_main_page">Сравнение карт</Nav.Link>
              <Nav.Link href="/dynamic_analysis_page">Анализ динамики</Nav.Link>
              <Nav.Link href="/settings_page">Настройки</Nav.Link>
              <NavDropdown title="Отчёт" id="basic-nav-dropdown">
                <NavDropdown.Item href="/reports_page">Статистический отчёт</NavDropdown.Item>
                {/* <NavDropdown.Item href="/statistic_reports_page">
                  Статистический отчёт
                </NavDropdown.Item>
                <NavDropdown.Item href="/factors_reports_page">Факторный отчёт</NavDropdown.Item> */}
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
